import { Organization } from '../../domain/organization/Organization';
import { OrganizationUser } from '../../domain/organization/OrganizationUser';
import { OrganizationResources } from '../../domain/resources/OrganizationResources';

export enum OrganizationActionType {
  FETCH_ORGANIZATION_SUCCESS = `FETCH_ORGANIZATION_SUCCESS`,
  UPDATE_ORGANIZATION_SUCCESS = `UPDATE_ORGANIZATION_SUCCESS`,
  FETCH_RESOURCES_SUCCESS = `FETCH_RESOURCES_SUCCESS`,
  RESET_ORGANIZATION = `RESET_ORGANIZATION`,
  FETCH_USERS_SUCCESS = `FETCH_USERS_SUCCESS`,
}

export interface FetchOrganizationSuccessAction {
  type: OrganizationActionType.FETCH_ORGANIZATION_SUCCESS;
  payload: {
    organization: Organization;
  };
}

export interface UpdateOrganizationSuccessAction {
  type: OrganizationActionType.UPDATE_ORGANIZATION_SUCCESS;
  payload: {
    organization: Organization;
  };
}

export interface FetchResourcesSuccessAction {
  type: OrganizationActionType.FETCH_RESOURCES_SUCCESS;
  payload: {
    resources: OrganizationResources;
  };
}

export interface FetchUsersSuccessAction {
  type: OrganizationActionType.FETCH_USERS_SUCCESS;
  payload: {
    users: OrganizationUser[];
  };
}

export interface ResetOrganizationAction {
  type: OrganizationActionType.RESET_ORGANIZATION;
}

export type OrganizationActions =
  | FetchOrganizationSuccessAction
  | UpdateOrganizationSuccessAction
  | FetchResourcesSuccessAction
  | ResetOrganizationAction
  | FetchUsersSuccessAction;
